import {
  useNormalizer,
} from '@sttedra_ui/framework';

const {
  getString,
  getNumber,
} = useNormalizer();

class RegisterApplicationsRequestApiResponseModel {
  // #region Props
  code;
  stateId;
  validationType;
  stateCode;
  serverDate;
  // #endregion

  constructor(data) {
    this.code = getString(data?.code);
    this.stateId = getNumber(data?.stateId);
    this.validationType = getString(data?.validationType);
    this.stateCode = getString(data?.stateCode);
    this.serverDate = getString(data?.serverDate);
  }
}

export default RegisterApplicationsRequestApiResponseModel;
